import React from 'react';

export default function App() {
  return (
    <div className="react-app">
      <p>React is running.</p>
    </div>
  );
}
